var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsdtwxg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2246_5369)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2246_5369",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 0C5.37271 0 0 5.37237 0 11.9999C0 18.6271 5.37271 24 12.0001 24C18.6274 24 24 18.6271 24 11.9999C24 5.37237 18.6273 0 12.0001 0Z",
    fill: "#4EAF94"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2246_5369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 0C5.37271 0 0 5.37237 0 11.9999C0 18.6271 5.37271 24 12.0001 24C18.6274 24 24 18.6271 24 11.9999C24 5.37237 18.6273 0 12.0001 0Z",
    fill: "#4EAF94"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2549 18V13.3283C16.1052 13.1712 18.2499 12.4888 18.25 11.6712C18.25 10.8537 16.1052 10.1714 13.2551 10.0141L13.2549 8.71131H16.8136V6H7.08278V8.71131H10.6411V10.0204C7.84309 10.1886 5.75 10.8636 5.75 11.6712C5.75 12.4789 7.84309 13.154 10.6411 13.322V18H13.2549ZM13.2551 11.8964V10.3105C15.7094 10.423 17.539 10.8586 17.5391 11.3794C17.5391 11.9857 15.059 12.4768 12 12.4768C8.94077 12.4768 6.46087 11.9857 6.46087 11.3794C6.46087 10.8661 8.23908 10.4353 10.6412 10.3153V10.6242H10.6415V11.8904C11.0745 11.9154 11.5296 11.9288 11.9999 11.9288C12.4327 11.9288 12.8531 11.9173 13.2551 11.8964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: -3,
    y: 14,
    width: 29,
    height: 7,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0223 20H9.78985V19.5455H9.55737V19.0909H9.32488V18.6364H9.09239V18.1818H8.8599V17.7273H8.62741V17.2727H8.39493V17.7273H8.16244V18.1818H7.92995V18.6364H7.69746V19.0909H7.46498V19.5455H7.23249V20H7V15H7.69746V17.5H7.92995V17.0455H8.16244V16.5909H8.39493V16.1364H8.62741V16.5909H8.8599V17.0455H9.09239V17.5H9.32488V15H10.0223V20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5112 20H12.8137V19.3182H12.5812V18.6364H12.3487V18.1818H12.1162V17.9545H11.8838V18.1818H11.6513V18.6364H11.4188V19.3182H11.1863V20H10.4888V19.3182H10.7213V18.6364H10.9538V18.1818H11.1863V17.7273H11.4188V17.2727H11.1863V16.8182H10.9538V16.3636H10.7213V15.6818H10.4888V15H11.1863V15.6818H11.4188V16.3636H11.6513V16.8182H11.8838V17.0455H12.1162V16.8182H12.3487V16.3636H12.5812V15.6818H12.8137V15H13.5112V15.6818H13.2787V16.3636H13.0462V16.8182H12.8137V17.2727H12.5812V17.7273H12.8137V18.1818H13.0462V18.6364H13.2787V19.3182H13.5112V20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 19.5455H16.7675V19.7727H16.535V20H14.9076V19.7727H14.6751V19.5455H14.4426V19.3182H14.2101V19.0909H13.9777V15.9091H14.2101V15.6818H14.4426V15.4545H14.6751V15.2273H14.9076V15H16.535V15.2273H16.7675V15.4545H17V15.9091H16.3025V15.6818H15.1401V15.9091H14.9076V16.1364H14.6751V18.8636H14.9076V19.0909H15.1401V19.3182H16.3025V17.9545H16.07V18.1818H15.3726V17.2727H17V19.5455Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2246_5369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdtwxg);
export default __webpack_public_path__ + "static/media/USDTWXG.84405fea3a040d43401308ed2d1754c4.svg";
export { ForwardRef as ReactComponent };